// extracted by mini-css-extract-plugin
export default {"wrapper":"CreatedTwoFA_wrapper__yDnNp","head":"CreatedTwoFA_head__6igQg","qr":"CreatedTwoFA_qr__7E39W","bottom":"CreatedTwoFA_bottom__qa5Wd","code":"CreatedTwoFA_code__Dmpuc"};